/* Muro recensioni — scorrimento infinito, filtri, "Altro".
   Difensivo: se un pezzo manca non lancia e non porta giù il resto della pagina. */
(function () {
  function inizializza(muro) {
    if (!muro || muro.dataset.muroPronto === '1') return;
    muro.dataset.muroPronto = '1';

    var base = parseInt(muro.dataset.velocita, 10) || 70;
    var piste = muro.querySelectorAll('[data-pista]');

    // Su schermo stretto le colonne diventano una sola riga di griglia: impilate
    // mostrerebbero uno spicchio di card ciascuna. Si uniscono in una pista sola,
    // alternando le colonne per non perdere l'ordine originale.
    if (window.matchMedia('(max-width: 768px)').matches && piste.length > 1) {
      var prima = piste[0];
      var code = [];
      Array.prototype.forEach.call(piste, function (p) {
        code.push(Array.prototype.slice.call(p.children));
      });
      var i = 0, messi = true;
      while (messi) {
        messi = false;
        for (var c = 0; c < code.length; c++) {
          if (code[c][i]) { prima.appendChild(code[c][i]); messi = true; }
        }
        i++;
      }
      Array.prototype.slice.call(piste, 1).forEach(function (p) {
        var col = p.closest('.muro__colonna');
        if (col) col.remove();
      });
      piste = muro.querySelectorAll('[data-pista]');
    }

    // duplica il contenuto di ogni pista: l'animazione va a -50%, così il giro è continuo
    Array.prototype.forEach.call(piste, function (pista, i) {
      var originali = Array.prototype.slice.call(pista.children);
      if (!originali.length) return;
      originali.forEach(function (n) {
        var copia = n.cloneNode(true);
        copia.setAttribute('aria-hidden', 'true');
        copia.dataset.copia = '1';
        // ⚠️ le copie NON devono portarsi dietro gli id: Shopify avvolge ogni
        // theme block in un wrapper con id univoco, e clonarlo produce id
        // duplicati (HTML non valido, e i link ancora rompono).
        if (copia.id) copia.removeAttribute('id');
        Array.prototype.forEach.call(copia.querySelectorAll('[id]'), function (e) {
          e.removeAttribute('id');
        });
        Array.prototype.forEach.call(copia.querySelectorAll('.fbr'), function (e) {
          e.dataset.copia = '1';
        });
        if (copia.classList && copia.classList.contains('fbr')) copia.dataset.copia = '1';
        // niente doppioni per chi legge con lo screen reader
        Array.prototype.forEach.call(copia.querySelectorAll('button, a'), function (e) {
          e.setAttribute('tabindex', '-1');
        });
        pista.appendChild(copia);
      });
      // colonne a velocità diverse, come nel riferimento
      pista.style.setProperty('--muro-durata', (base + i * 14) + 's');
      pista.style.setProperty('--muro-ritardo', (-i * 6) + 's');
    });

    // "Altro" sui commenti lunghi
    function misuraTroncamento() {
      Array.prototype.forEach.call(muro.querySelectorAll('[data-fbr-testo]'), function (t) {
        var bottone = t.parentNode.querySelector('[data-fbr-altro]');
        if (!bottone) return;
        if (t.dataset.aperto === '1') return;      // l'utente l'ha aperto: non toccarlo

        // 🔑 prima si tronca, POI si misura. Misurando prima, scrollHeight e
        //    clientHeight coincidono e il bottone non compariva mai.
        t.classList.add('is-troncato');
        var serve = t.scrollHeight > t.clientHeight + 4;
        bottone.hidden = !serve;
        if (!serve) t.classList.remove('is-troncato');
        if (serve && !bottone.dataset.legato) {
          bottone.dataset.legato = '1';
          bottone.addEventListener('click', function () {
            var aperto = !t.classList.contains('is-troncato');
            t.classList.toggle('is-troncato', aperto);
            t.dataset.aperto = aperto ? '0' : '1';
            bottone.textContent = aperto ? 'Altro' : 'Mostra meno';
          });
        }
      });
    }

    misuraTroncamento();
    // ⚠️ misurata col font di ripiego, una riga occupa più spazio e "Altro"
    //    compariva anche su commenti che stavano tutti. Si rimisura a font pronti.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { setTimeout(misuraTroncamento, 60); });
    }
    var rid;
    window.addEventListener('resize', function () {
      clearTimeout(rid); rid = setTimeout(misuraTroncamento, 200);
    });

    // filtri
    var filtri = muro.querySelectorAll('[data-filtro]');
    Array.prototype.forEach.call(filtri, function (b) {
      b.addEventListener('click', function () {
        var voluto = b.dataset.filtro;
        Array.prototype.forEach.call(filtri, function (x) {
          var attivo = x === b;
          x.classList.toggle('is-attivo', attivo);
          x.setAttribute('aria-selected', attivo ? 'true' : 'false');
        });
        var primo = filtri[0] && filtri[0].dataset.filtro;
        Array.prototype.forEach.call(muro.querySelectorAll('.fbr'), function (c) {
          var mostra = (voluto === primo || c.dataset.categoria === voluto);
          // ⚠️ Shopify avvolge ogni theme block in un div: nascondere solo la
          //    card lascia il contenitore come figlio del flex, e la `gap`
          //    continua a contare → buchi enormi fra i commenti filtrati.
          //    Si nasconde il contenitore, cioè il figlio diretto della pista.
          var bersaglio = c;
          while (bersaglio.parentNode && !bersaglio.parentNode.hasAttribute('data-pista')) {
            bersaglio = bersaglio.parentNode;
            if (bersaglio === muro) { bersaglio = c; break; }
          }
          bersaglio.hidden = !mostra;
          if (bersaglio !== c) c.hidden = !mostra;
        });
      });
    });
  }

  function avvia() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-muro]'), inizializza);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
  // il theme editor ricarica le sezioni: reinizializza
  document.addEventListener('shopify:section:load', avvia);
})();
